import { ofetch } from 'ofetch'
import { config } from '@/config.settings'
import {
  apiMethods,
  parseApiResponse,
  catchApiError,
} from '@/contexts/shared/api/constructor/ApiFetcherConstructor.helpers'
import type { TranslatedFields } from '@/interfaces/Language.interfaces'
import { redirectIfUnauthorized } from '@/contexts/shared/api/constructor/ApiFetcherConstructor.composables'

const apiFetch = ofetch.create({
  baseURL: config.base_url,
  credentials: 'include',
  ignoreResponseError: true,
  onRequestError() {
    document.location.href = '/'
  },
})

export interface UseApiRestErrorData {
  errors: TranslatedFields
}

const apiFetcher = <T, E>(url: string, options = {}) =>
  apiFetch
    .raw<T>(url, options)
    .then(parseApiResponse<T, E>)
    .then(redirectIfUnauthorized<T, E>)
    .catch(catchApiError<E>)

export const useApiRest = apiMethods<UseApiRestErrorData>(apiFetcher)
